<template>
  <div class="horizontal-selector">
    <button
      v-for="(opt, i) in options"
      :key="i"
      @click="$emit('select', opt.value)"
      :class="{ filled: active === opt.value }"
    >
      {{ opt.name }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    active: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.horizontal-selector {
  vertical-align: baseline;
  margin-bottom: 0.7rem;

  > button {
    padding: 1px 12px;
    border: 1px solid #00a6cb;
    color: #00a6cb;
    background-color: transparent;
    transition: background-color 0.3s;
    font-size: 1rem;

    &:hover {
      background-color: #00a6cb33;
    }

    &.filled {
      color: white;
      background-color: #00a6cb;
    }
    &:last-child {
      border-radius: 0px 4px 4px 0px;
    }
    &:first-child {
      border-radius: 4px 0px 0px 4px;
    }
    &:not(:last-child) {
      border-right: none;
    }
  }
}
</style>
